import { useState } from 'react';
import clsx from 'clsx';

type LoginBrandProps = { logoUrl?: string | null; systemName: string };

export const LoginBrand = ({ logoUrl, systemName }: LoginBrandProps) => {
  const [failedSource, setFailedSource] = useState<string>();
  const defaultSource = '/media/logos/easypdv-logo-dark.svg';
  const source = logoUrl && failedSource !== logoUrl ? logoUrl : defaultSource;
  const usesDefault = source === defaultSource;
  const handleImageError = () => setFailedSource(logoUrl ?? undefined);
  const onError = usesDefault ? undefined : handleImageError;
  return (
    <img
      alt={systemName}
      className={clsx('login-brand-image', { 'login-brand-default': usesDefault })}
      src={source}
      onError={onError}
    />
  );
};
